import React from 'react'

import LoadingSpinner from 'Components/LoadingSpinner'

export default class Modal extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      modalTransitions: false
    }
  }

  componentDidMount () {
    this.setState(prevState => ({ modalTransitions: !prevState.modalTransitions }))
  }

  titleClasses () {
    const classNames = ['modal__content-header-title']
    const { warning, info } = this.props

    if (warning) { classNames.push('modal__header-warning') } else if (info) { classNames.push('modal__header-info') }

    return classNames.join(' ')
  }

  alertIcon () {
    const { warning, info } = this.props
    let alert

    if (warning) {
      alert = <span className="lnr lnr-warning" />
    }

    if (info) {
      alert = <span className="lnr lnr-question-circle" />
    }

    return alert
  }

  render () {
    const {
      showModal,
      title,
      children,
      removeModal,
      processing,
      largeModal,
      card,
      cardSizeClass
    } = this.props
    const { modalTransitions } = this.state

    return (
      <div
        className={`modal-wrap ${modalTransitions && 'modal-wrap--transitions'} ${showModal && 'modal-wrap--visible'}`}
        onClick={removeModal}
      >
        <div className={`modal modal--responsive ${largeModal && 'modal--large'}`}>
          <section className={`modal__content ${card && 'card card--allow-overflow'}` } onClick={event => event.stopPropagation()}>
            { processing && <LoadingSpinner withOverlay /> }
            <header className="modal__content-header">
              <h3 className={this.titleClasses()}>
                {this.alertIcon()}
                {title}
              </h3>
              <i className="modal__close" onClick={removeModal} />
            </header>
            <div className={cardSizeClass ?? 'card--padding-large'}>
              {children}
            </div>
          </section>
        </div>
      </div>
    )
  }
}

Modal.defaultProps = {
  showModal: true,
  card: true,
  removeModal (event) {
    if (event.target) {
      event.target.closest('.modal-wrap').classList.toggle('modal-wrap--visible')
    }
  }
}
